import script from "./ParcelTracker.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcelTracker.vue?vue&type=script&setup=true&lang=js"

import "./ParcelTracker.vue?vue&type=style&index=0&id=1543b9ad&lang=css"

const __exports__ = script;

export default __exports__